import { useEntitlementCheck } from '@/hooks/entitlements'

/**
 * Hook to check if the current billing organization has Salesforce entitlement.
 * Uses SpiceDB-based entitlement checks.
 *
 * @returns boolean indicating whether the organization has Salesforce entitlement (defaults to false while loading)
 */
export const useCanEnableSalesforce = () => {
  const { data } = useEntitlementCheck({ entitlement: 'salesforce' })
  return data ?? false
}
